import React, { useState } from 'react'
import { KpiSparkline } from './KpiSparkline.jsx'

export function KpiFacet({ kpi, onUpdateCurrent }) {
  const [editing, setEditing] = useState(false)
  const [draft, setDraft] = useState('')

  if (!kpi) return null

  const isDown = kpi.direction === 'down'
  let pct = 0
  if (kpi.target != null) {
    if (isDown) {
      const start = kpi.history?.[0]?.value ?? kpi.current
      const totalRange = start - kpi.target
      const progress = start - kpi.current
      pct = totalRange > 0 ? Math.round((progress / totalRange) * 100) : 0
    } else {
      pct = Math.round((kpi.current / kpi.target) * 100)
    }
  }
  pct = Math.max(0, Math.min(pct, 100))

  function startEdit() {
    setDraft(String(kpi.current))
    setEditing(true)
  }

  function commitEdit() {
    const val = parseInt(draft, 10)
    if (!isNaN(val)) onUpdateCurrent?.(val)
    setEditing(false)
  }

  return (
    <div style={styles.facet}>
      <div style={styles.row}>
        <div style={styles.values}>
          {editing ? (
            <input
              style={styles.editInput}
              type="number"
              value={draft}
              onChange={(e) => setDraft(e.target.value)}
              onBlur={commitEdit}
              onKeyDown={(e) => e.key === 'Enter' && commitEdit()}
              autoFocus
            />
          ) : (
            <span style={styles.current} onClick={onUpdateCurrent ? startEdit : undefined}>
              {kpi.current}
            </span>
          )}
          <span style={styles.separator}>/</span>
          <span style={styles.target}>{kpi.target}</span>
          {kpi.unit && <span style={styles.unit}>{kpi.unit}</span>}
          {isDown && <span style={styles.dirHint} title="Lower is better">{'\u2193'}</span>}
        </div>
        <KpiSparkline history={kpi.history || []} direction={kpi.direction} />
      </div>
      <div style={styles.bar}>
        <div style={{ ...styles.barFill, width: `${Math.min(pct, 100)}%` }} />
      </div>
    </div>
  )
}

const styles = {
  facet: { display: 'flex', flexDirection: 'column', gap: '4px' },
  row: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px' },
  values: { display: 'flex', alignItems: 'baseline', gap: '2px' },
  current: { fontSize: '16px', fontWeight: 600, color: 'var(--text-primary)', cursor: 'pointer' },
  separator: { fontSize: '12px', color: 'var(--text-secondary)' },
  target: { fontSize: '12px', color: 'var(--text-secondary)' },
  unit: { fontSize: '10px', color: 'var(--text-secondary)', marginLeft: '4px' },
  dirHint: { fontSize: '10px', color: 'var(--text-secondary)', marginLeft: '2px' },
  editInput: {
    width: '60px',
    fontSize: '14px',
    padding: '2px 6px',
    border: '1px solid var(--border)',
    borderRadius: '4px',
    background: 'var(--bg)',
    color: 'var(--text-primary)',
  },
  bar: {
    height: '4px',
    background: '#f0f0ee',
    borderRadius: '2px',
    overflow: 'hidden',
  },
  barFill: {
    height: '100%',
    background: '#3a8a5a',
    borderRadius: '2px',
    transition: 'width var(--duration-slow) ease',
  },
}
